import api from "@/api";
import BatterTableDataView from "@/components/BatterTableDataView";
export default {
  name: "ShopTypeSettingView",
  components: {
    BatterTableDataView
  },
  data() {
    return {
      enableMap: {},
      createVisible: false,
      initQuery: {}
    };
  },
  methods: {
    enableChange(id, val) {
      this.enableMap[id] = val;
      api.updateShopTypeEnableState(id, val);
    },
    onFetchData(d) {
      for (let itm of d.list) {
        this.enableMap[itm.id] = itm.enable;
      }
    },
    createShopType(data) {
      api.createShopType(data).then(() => {
        this.createVisible = false;
        this.initQuery = {
          'fresh': new Date()
        };
      });
    }
  }
};